module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_7042.cdde4d81.png";